import { Component, OnInit } from '@angular/core';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ComprobanteService } from 'src/app/DataAccess/comprobantes.service';
import { CComprobanteData } from 'src/app/Model/ccomprobante.model';

@Component({
  selector: 'app-modal-documento',
  templateUrl: './modal-documento.component.html',
  styleUrls: ['./modal-documento.component.css']
})
export class ModalDocumentoComponent implements OnInit {

  public showLoadingSpinner: boolean = false;
  public showError: boolean = false;

  pdf64: string;
  xml64: string;
  public EnvioSuccess: boolean = false;
  public EnvioFailed: boolean = false;

  public Id: string = "";

  constructor(public dialogRef: MatDialogRef<ModalDocumentoComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private generarComprobante:ComprobanteService) {
    // this.Id = id;
    console.log(data.data.data)
    console.log("###",data.data.exists)
  }

  ngOnInit(): void {
  }

  cerrarDialog(){
    this.dialogRef.close();
  }

  procesarComprobantePDF() {
    let cuerpo = new CComprobanteData()
    cuerpo.CodigoCaptcha = ''
    cuerpo.FechaEmision = this.data.data.data.fechaEmision
    cuerpo.MontoTotal = this.data.data.data.montoTotal
    cuerpo.Ruc = this.data.data.data.ruc
    cuerpo.SerieNumero = this.data.data.data.serieNumero
    cuerpo.TipoComprobante = this.data.data.data.tipoComprobante

    console.log("Este es el cuerpoooooo", cuerpo)

    this.generarComprobante.consultaDocs(cuerpo).subscribe(
      data => {
        console.log('datos enviados correctamente')
        //this.EnvioSuccess = true

        console.log("datosssssss: " ,data.base64ResultPdf)

        this.pdf64 = "data:application/pdf;base64, " + data.base64ResultPdf
        this.xml64 = "data:application/xml;base64, " + data.base64ResultXml
        const source = this.pdf64;
        const link = document.createElement("a");
        link.href = source;
        link.download = `comprobantePDF.pdf`
        link.click();

      }, error => {
        this.EnvioFailed = true;
        console.log(error)
      }, () => { }
    )

  }

  procesarComprobanteXML() {
    let cuerpo = new CComprobanteData()

    cuerpo.CodigoCaptcha = ''
    cuerpo.FechaEmision = this.data.data.data.fechaEmision
    cuerpo.MontoTotal = this.data.data.data.montoTotal
    cuerpo.Ruc = this.data.data.data.ruc
    cuerpo.SerieNumero = this.data.data.data.serieNumero
    cuerpo.TipoComprobante = this.data.data.data.tipoComprobante

    console.log("Este es el cuerpoooooo", cuerpo)

    this.generarComprobante.consultaDocs(cuerpo).subscribe(
      data => {
        console.log('datos enviados correctamente')
        this.EnvioSuccess = true

        console.log("datosssssss: " ,data.base64ResultPdf)

        this.pdf64 = "data:application/pdf;base64, " + data.base64ResultPdf
        this.xml64 = "data:application/xml;base64, " + data.base64ResultXml
        const source = this.xml64;
        const link = document.createElement("a");
        link.href = source;
        link.download = `comprobanteXML.xml`
        link.click();

      }, error => {
        this.EnvioFailed = true;
        console.log(error)
      }, () => { }
    )

  }


}
